// Indian fuel station brand registry.
// Each brand's display logo lives at /brand-logos/<id>.svg in the public folder.
// You can replace any of those files with your own PNG/SVG (keep the same filename).

export const FUEL_BRANDS = [
  {
    id: 'indianoil',
    name: 'IndianOil',
    primary: '#003B7A',
    logoUrl: '/brand-logos/indianoil.svg',
  },
  {
    id: 'bpcl',
    name: 'Bharat Petroleum',
    primary: '#003F87',
    logoUrl: '/brand-logos/bpcl.svg',
  },
  {
    id: 'hpcl',
    name: 'HP',
    primary: '#005EB8',
    logoUrl: '/brand-logos/hpcl.svg',
  },
  {
    id: 'reliance',
    name: 'Reliance',
    primary: '#00529B',
    logoUrl: '/brand-logos/reliance.svg',
  },
  {
    id: 'nayara',
    name: 'Nayara',
    primary: '#E94E1B',
    logoUrl: '/brand-logos/nayara.svg',
  },
  {
    id: 'shell',
    name: 'Shell',
    primary: '#DD1D21',
    logoUrl: '/brand-logos/shell.svg',
  },
  {
    id: 'essar',
    name: 'Essar',
    primary: '#003F87',
    logoUrl: '/brand-logos/essar.svg',
  },
  {
    id: 'generic',
    name: 'Fuel Station',
    primary: '#1F2937',
    logoUrl: '/brand-logos/generic.svg',
  },
];

export const getBrand = (id) =>
  FUEL_BRANDS.find((b) => b.id === id) || FUEL_BRANDS[0];

export const hexToRgb = (hex) => {
  const clean = hex.replace('#', '');
  const num = parseInt(
    clean.length === 3
      ? clean.split('').map((c) => c + c).join('')
      : clean,
    16
  );
  return [(num >> 16) & 255, (num >> 8) & 255, num & 255];
};

/**
 * Load a brand logo (SVG or raster) and return a PNG data URL suitable for
 * jsPDF's addImage(). SVGs are rasterized via an offscreen canvas.
 */
export const loadLogoAsPng = (url, size = 320) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');
        // transparent background
        ctx.clearRect(0, 0, size, size);
        ctx.drawImage(img, 0, 0, size, size);
        resolve(canvas.toDataURL('image/png'));
      } catch (err) {
        reject(err);
      }
    };
    img.onerror = reject;
    img.src = url;
  });
